<template>
  <div class="ps-3 mt-2">
    <table
      class="table table-bordered table-hover table-responsive"
      style="cursor: pointer"
    >
      <thead>
        <tr class="bg-tr-color">
          <th>Bil</th>
          <th>Salgsdato</th>
          <th>Beløp</th>
          <th>Fraktkostnader</th>
          <th>Status</th>
          <th>{{ trans('order_deliveries.link') }}</th>
          <th>{{ trans('order_deliveries.copy') }}</th>
        </tr>
      </thead>
      <tbody class="border-top-0">
        <tr
          v-for="orderDelivery in order_deliveries"
          :key="orderDelivery.id"
        >
          <td>{{ orderDelivery.car_name }}</td>
          <td>{{ orderDelivery.sale_date }}</td>
          <td style="white-space: nowrap;">{{ orderDelivery.amount }}</td>
          <td>{{ orderDelivery.order_price_vat ?? orderDelivery.price }}</td>
          <td :class="{ delivery_red: orderDelivery.status_code === 'cancelled' || orderDelivery.status_code === 'failed',
                        delivery_green: orderDelivery.status_code === 'completed' }"
          >
            {{ trans('order_deliveries.status.' + orderDelivery.status_code) }}
            <div
              v-if="['paid', 'in_progress', 'pre_trip_inspection', 'post_trip_inspection'].includes(orderDelivery.status_code) && !!orderDelivery.delivery_date"
              class="delivery-info"
            >
              {{ trans('order_deliveries.delivery_date').replace(':delivery_date', orderDelivery.delivery_date)
                .replace(':start_delivery_time', orderDelivery.delivery_start_at)
                .replace(':end_delivery_time', orderDelivery.delivery_end_at)
              }}
            </div>
          </td>
          <td style="white-space: nowrap;">
            <a
              v-if="!orderDelivery.paid_date && orderDelivery.invoice_link"
              :href="orderDelivery.invoice_link"
              target="_blank"
            >
              {{ trans('order_deliveries.download') }}
            </a>
          </td>
          <td>
            <button
              v-if="!orderDelivery.paid_date && orderDelivery.invoice_link"
              class="btn btn-tooltip btn-primary"
              :data-tooltip="trans('order_deliveries.modal.tooltip')"
              data-toggle="modal"
              data-target="#sendMail"
              @click="sentOrderDeliveryId = orderDelivery.id"
            >
              <i class="fas fa-paper-plane" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <SendInvoiceModal
    modal-id="sendMail"
    :invoicing-email="email"
    @send="sendMessage"
  />
</template>

<script>

import SendInvoiceModal from "../invoices/SendInvoiceModal.vue";

export default {
  name: "ListOrderDeliveriesComponent",
  components: {SendInvoiceModal},
  props: {
    order_deliveries: {
      type: Array
    },
    email: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      sentOrderDeliveryId: null
    }
  },
  methods: {
    sendMessage(email) {
      axios({
        url: `/my/deliveries/send-invoice/${this.sentOrderDeliveryId}`,
        method: 'POST',
        data: {
          email: email
        }
      }).then(resp => {
        this.errorMessage = '';

        this.responseMessage = resp.data;
      }).catch(err => {
        this.errorMessage = err.message
      }).finally(() => {
        this.sentOrderDeliveryId = null;
      })
    }
  }
}
</script>

<style>
.delivery-info {
  font-size: 12px;
}
.delivery_red {
  color: red;
}
.delivery_green {
  color: green;
}
</style>
